import { useEffect } from 'react';

// WCAG 2.1 AA helpers for the warehouse web port.

// Props for a div/span acting as a button: role + keyboard operability +
// optional disabled state. Use on elements whose content can't legally
// live inside a real <button> (cards with block-level children).
export const buttonProps = (onClick, { disabled = false } = {}) => ({
  role: 'button',
  tabIndex: disabled ? undefined : 0,
  'aria-disabled': disabled || undefined,
  onClick: disabled ? undefined : onClick,
  onKeyDown: disabled
    ? undefined
    : (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick(event);
        }
      },
});

// Props for a div acting as a checkbox toggle (item rows, rule rows):
// role + checked state + keyboard operability (Enter/Space toggles).
export const checkboxProps = (checked, onToggle, { disabled = false } = {}) => ({
  role: 'checkbox',
  'aria-checked': checked,
  tabIndex: disabled ? undefined : 0,
  'aria-disabled': disabled || undefined,
  onClick: disabled ? undefined : onToggle,
  onKeyDown: disabled
    ? undefined
    : (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onToggle(event);
        }
      },
});

// Keeps the browser tab title in step with the current warehouse screen
// (WCAG 2.4.2 - the SPA would otherwise show "Pack Perfect" everywhere)
export const useDocumentTitle = (title) => {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} — Pack Perfect` : previous;
    return () => {
      document.title = previous;
    };
  }, [title]);
};
